module.exports = __webpack_public_path__ + "img/download.b552db5b.svg";